import { useInfoModalStore } from 'shared/store/info-modal';

export const useInfoModal = () => {
  const { close, open } = useInfoModalStore((state) => state);
  return {
    close,
    open,
  };
};
